import { render, staticRenderFns } from "./TeacherSlider.vue?vue&type=template&id=5e8612a0&scoped=true&"
import script from "./TeacherSlider.vue?vue&type=script&lang=js&"
export * from "./TeacherSlider.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSlider.vue?vue&type=style&index=0&id=5e8612a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8612a0",
  null
  
)

export default component.exports